var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTy10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "600.000000pt",
    height: "600.000000pt",
    viewBox: "0 0 600.000000 600.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,600.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1580 4805 l0 -675 -655 0 -655 0 0 -660 0 -660 655 0 655 0 0 -660 0 -660 670 0 670 0 0 660 0 660 655 0 655 0 0 660 0 660 -655 0 -655 0 0 675 0 675 -670 0 -670 0 0 -675z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5130 2203 c-112 -19 -241 -94 -301 -175 -109 -148 -159 -356 -159 -661 0 -573 161 -817 540 -817 245 0 414 112 501 332 97 244 99 762 5 1013 -63 167 -167 262 -328 300 -58 14 -199 18 -258 8z m256 -209 c125 -77 179 -268 177 -634 -1 -415 -83 -596 -285 -630 -162 -28 -283 46 -337 206 -38 115 -46 189 -46 449 0 201 4 266 18 330 36 163 105 264 206 302 23 9 68 12 127 10 82 -2 97 -6 140 -33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3923 2190 c-36 -15 -387 -242 -405 -263 -12 -13 -18 -36 -18 -72 0 -65 7 -85 29 -85 10 0 90 43 180 96 89 53 164 95 166 92 2 -2 5 -276 5 -608 l2 -605 -173 -3 c-95 -1 -178 -7 -185 -12 -20 -17 -26 -87 -10 -125 l15 -35 440 0 441 0 16 25 c12 18 15 39 12 70 -9 74 -10 75 -184 75 l-154 0 0 720 0 720 -26 10 c-31 12 -121 12 -151 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTy10);
export default __webpack_public_path__ + "static/media/TY10.ac8a41d819d3f68bb4e7aae6a28c7ed5.svg";
export { ForwardRef as ReactComponent };